import React, { useEffect, useState } from "react";
import {  Modal } from "react-bootstrap";
import AddForm from "../common/Loan_Form/Loan_Form";
import styles from "./Modal.module.css";
import CareerForm from "../common/CareerForm/CareerForm";

function FormModal({ pageHeading }) {
  const [show, setShow] = useState(false);
  const [path, setPath] = useState(false);
  useEffect(() => {
    if (window?.location?.pathname) {
      let pathmatch = window.location.pathname.toString().includes("/careers");
      setPath(pathmatch);
    }
  }, []);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div>
      <button
        className={`${!path ? styles.counter_btns : styles.apply_now_btn} 
        ${!path ? styles.cta : styles.cta_change} mb-4`}
        onClick={handleShow}
      >
        <span>
          Apply Now
          <svg viewBox="0 0 13 10" height="10px" width="15px">
            <path d="M1,5 L11,5"></path>
            <polyline points="8 1 12 5 8 9"></polyline>
          </svg>
        </span>
      </button>
      <Modal
        size="lg"
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {!path ? (
              <span className="ps-4">
                <span>Application Form -</span>
                <span className="text_orange"> {pageHeading + " Loan"}</span>
              </span>
            ) : (
              <span className="text_orange ps-4">
                Feel free to get in touch
              </span>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!path ? <AddForm pageHeading={pageHeading} /> : <CareerForm />}
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default FormModal;
